export default __webpack_public_path__ + "static/media/Elder Wand - Img - Wip 2_03.04a5ca5a.jpg";